import { ProjectDataUnity } from './project-data-unity.entity';
import { ProjectDataNavision } from './project-data-navision-entity';

export class ProjectDataPresupuesto {
	public unity: ProjectDataUnity = new ProjectDataUnity();
	public others: string = '';
	public conceptos: any[] = [];
	public navision: ProjectDataNavision = new ProjectDataNavision();
	public error: string = "";
	public dataCoors3D: any[] = [];
}